module.exports = __webpack_public_path__ + "img/parrot-speaking.07702851.png";